import { applyMiddleware, compose, createStore } from "redux";

import {errorHandler} from "../util/errorHandlerMiddleware.js";
import thunkMiddleware from "redux-thunk";

const createStoreWithMiddleware = compose(
    applyMiddleware(
        errorHandler,
        thunkMiddleware // lets us dispatch() functions
    )
)(createStore);

/**
 * @returns {*}
 */
export default function(rootReducer) {
    const store = createStoreWithMiddleware(rootReducer);
    return store;
}